
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/figjam-to-lucidchart",
      function () {
        return require("private-next-pages/converter/figjam-to-lucidchart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/figjam-to-lucidchart"])
      });
    }
  